// Client and Project list
export const ClientList = [
  {
    img: "/art-sticker.jpg",
    title: "Art Pennington",
    description:
      "Art Pennington (1923-2017) was a legendary baseball player whose achievements transcended the diamond.",
    tech_stack: ["DNS Setup", "Email Setup", "SEO", "Wix Hosting","Still in initial build phase, ecommerce set up coming"],
    github_url: "https://github.com/tektechnologies/Art-Pennington-Baseball",
    demo_url: "https://www.artpenningtonbaseball.com/",
  },
  {
    img: "/SAFE_Logo.png",
    title: "SAFE",
    description:
      "Our mission is to ban fracking and other fossil fuel extraction in, and shipment of fossil fuels through, Southern Illinois.",
    tech_stack: ["DNS Setup", "Email Setup", "SEO", "Wix Hosting", "Virus Removal","User Training on Internet Products"],
    github_url: "https://github.com/tektechnologies/SAFE-fracking-site",
    demo_url: "https://www.dontfractureillinois.org/",
  },
  {
    img: "/Round-Logo.jpg",
    title: "Rare Bird Soap Shop",
    description:
      "Rare Bird Soap Shop is a small, woman-owned business that specializes in quality handcrafted soaps and skin care products. All products are handcrafted by Wende Fugate, owner and founder of Rare Bird Soap Shop.",
    tech_stack: [ "Godaddy Hosting", "User Training on Internet Products","Ecommerce setup on Square" ,"SEO"],
    github_url: "https://github.com/tektechnologies/SAFE-fracking-site",
    demo_url: "https://www.rarebirdsoapshop.store/",
  },
  {
    img: "/upnorth.png",
    title: "Up North Getaway!",
    description:
      " Cozy Cottage is a wonderfully furnished, year-round home located on the beautiful shores of Big St. Germain Lake.",
    tech_stack: ["DNS Setup", "Email Setup", "SEO", "Godaddy Hosting", "SSL","Logo Design and Marketing Materials "],
    github_url: "https://tektechnologies.github.io/upnorthgetaway/",
    demo_url: "https://tektechnologies.github.io/upnorthgetaway/",
  },
  {
    img: "/CLC_Logo.jpg",
    title: "Central LimeStone",
    description:
      " Central Limestone Company, Inc. is a crushed stone manufacturer supplying local markets with high quality aggregates for Road Base and Surface Courses.",
    tech_stack: ["HTML", "CSS", "JS", "MediaNetWifi Hosting","Logo Design and Client Meetings "],
    github_url: "https://tektechnologies.github.io/centrallimestone/",
    demo_url: "https://tektechnologies.github.io/centrallimestone/",
  },

]


export const stackList = [
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original.svg",
    name: "HTML",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original.svg",
    name: "CSS",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg",
    name: "JavaScript",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original.svg",
    name: "ReactJS",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg",
    name: "Typescript",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/git/git-original.svg",
    name: "Git",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original.svg",
    name: "React Native",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original.svg",
    name: "NodeJS",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original.svg",
    name: "MongoDB",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
    name: "Python",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/c/c-original.svg",
    name: "C#",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
    name: "Java",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original.svg",
    name: "MySQL",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/bootstrap/bootstrap-original.svg",
    name: "Bootstrap",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/materialui/materialui-original.svg",
    name: "Material UI",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/figma/figma-original.svg",
    name: "Figma",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/vscode/vscode-original.svg",
    name: "VS Code",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/eslint/eslint-original.svg",
    name: "eslint",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/ansible/ansible-original.svg",
    name: "Ansible",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/axios/axios-plain.svg",
    name: "Axios",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/postgresql/postgresql-original-wordmark.svg",
    name: "postgresql",
  },
];


// https://github.com/devicons/devicon